import pkg from "../../package.json";
import { EnvSettings } from "../domain/envSettings";
import { envDecoder } from "../decoders/envDecoder";
import { Result, OK, ERR } from "json-decoder";

export const ENV_BRAND_NWB = "nwb";
export const ENV_BRAND_RBS = "rbs";
export const ENV_BRAND_UBN = "ubn";

export type EnvBrand =
  | typeof ENV_BRAND_NWB
  | typeof ENV_BRAND_RBS
  | typeof ENV_BRAND_UBN;

export type BrandedConfig<T = string> = {
  [ENV_BRAND_NWB]: T;
  [ENV_BRAND_RBS]: T;
  [ENV_BRAND_UBN]: T;
};

const ENV_LOCAL = "local";
const ENV_DEV1 = "dev1";
const ENV_DEV2 = "dev2";
const ENV_QA1 = "qa1";
const ENV_QA2 = "qa2";
const ENV_PROD = "prod";
const ENV_NFT = "nft";

export type EnvType =
  | typeof ENV_LOCAL
  | typeof ENV_DEV1
  | typeof ENV_DEV2
  | typeof ENV_QA1
  | typeof ENV_QA2
  | typeof ENV_PROD
  | typeof ENV_NFT;

export const env = (): EnvType => {
  const currentEnv = process.env.REACT_APP_ENV || ENV_LOCAL;
  return currentEnv.toLowerCase() as EnvType;
};

export const getVersion = (): string =>
  process.env.REACT_APP_VERSION || pkg.version;

export const brand = (): EnvBrand => {
  const currentBrand = process.env.REACT_APP_BRAND || ENV_BRAND_NWB;
  return currentBrand.toLowerCase() as EnvBrand;
};

export const isProduction = (): boolean => env() === ENV_PROD;

export const envSettings = (): EnvSettings => {
  const json = require(`../env/${brand()}_${env()}.json`);
  const envSettings: Result<EnvSettings> = envDecoder.decode(json);
  switch (envSettings.type) {
    case OK:
      return envSettings.value;
    case ERR:
      throw new Error(envSettings.message);
  }
};
